import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { TemplateList } from '@/components/whatsapp/template-list'
import { useWATemplateStats } from '@/hooks/useWATemplates'

export const Route = createFileRoute('/whatsapp-templates')({
  component: WhatsAppTemplatesPage,
})

function WhatsAppTemplatesPage() {
  const { data: stats } = useWATemplateStats()

  const subtitle = stats
    ? `${stats.total} templates · ${stats.byStatus.approved} approved`
    : 'Loading templates...'

  return (
    <div className="flex flex-col h-full">
      <Header title="Message Templates" subtitle={subtitle} />
      <div className="flex-1 overflow-hidden">
        <TemplateList />
      </div>
    </div>
  )
}
